import styled from 'styled-components'
import { flag } from 'country-emoji'
import Image from 'next/legacy/image'
import { Typography } from 'common/typography'
import { useInfiniteReviews } from 'querys/reviews'
import Stars from 'learning/stars'
import useIntersectionObserver from 'hooks/use-intersection-observer'
import ReviewsPlaceholder from './reviews-placeholder'

const InfiniteReviewsStyled = styled.section`
  margin-block-start: -80px;
  margin-block-end: 80px;
  h1 {
    width: fit-content;
    margin: 0 auto;
  }
  .observer {
    height: 1px;
  }
  .review-list {
    padding: 0 16px;
    display: grid;
    grid-row-gap: 40px;
    margin-block-start: 48px;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  }
  @media(min-width: 1024px) {
    margin-block-end: 160px;
    .review-list {
      padding: 0 64px;
      grid-column-gap: 40px;
      grid-row-gap: 64px;
    }
  }
  @media(min-width: 1600px) {
    .review-list {
      grid-template-columns: repeat(4, 1fr);
    }
  }
`

const ReviewStyled = styled.li`
  .author {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-block-end: 16px;
    &-name {
      color: var(--baseNeutral);
      font-weight: 700;
    }
    &-photo-container {
      background: linear-gradient(51.32deg, #FA057C 0%, #0704FE 100%, rgba(196, 196, 196, 0) 100%);
      border-radius: 50%;
      overflow: hidden;
      height: 50px;
      width: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &-photo {
      border-radius: 50%;
      overflow: hidden;
      height: 48px;
      width: 48px;
    }
  }
  .review-description {
    font: var(--regular);
  }
`

function InfiniteReviews() {
  const query = useInfiniteReviews()
  const {
    data, isLoading, isError, fetchNextPage, isFetchingNextPage,
  } = query
  const { ref: lastReview } = useIntersectionObserver({
    onIntersect: () => fetchNextPage(),
    rootMargin: '0px 0px 500px 0px',
  })
  if (isLoading || isError) return null
  const { pages: reviews } = data

  return (
    <InfiniteReviewsStyled>
      <Typography as="h1" small="headline5" large="headline3">
        Opiniones de estudiantes
      </Typography>
      <ul className="review-list">
        {
          reviews.map((page) => page.results && (
            page.results.map(({ author, stars, comment, country_code }) => (
              <ReviewStyled>
                <div className="author">
                  <div className="author-photo-container">
                    <div className="author-photo">
                      <Image src={author.photo} alt={author.full_name} width={48} height={48} />
                    </div>
                  </div>
                  <div>
                    <p className="author-name">
                      {author.full_name}
                      {' '}
                      {flag(country_code)}
                    </p>
                    <Stars align="flex-start" stars={parseInt(stars, 10)} size={16} gap={0} />
                  </div>
                </div>
                <p className="review-description">{comment}</p>
              </ReviewStyled>
            ))
          ))
        }
        {isFetchingNextPage && <ReviewsPlaceholder />}
      </ul>
      <div ref={lastReview} className="observer" />
    </InfiniteReviewsStyled>
  )
}

export default InfiniteReviews
